export const SAVE_ACCRUAL_FORM_DATA = "/scheme-planning/ims/accrual/save";
export const ACCRUAL_LIST_URL =
  "/scheme-planning/ims/accrual/list?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const GET_SAVED_ACCRUAL_FORM_URL =
  "/scheme-planning/ims/accrual?accrualNumber={accrualId}";
export const SAVE_ASSOCIATED_PLAN_DATA =
  "/scheme-planning/ims/accrual/savePlan?divisionDimKey={division}&accrualNumber={accrualNo}";
export const GET_ACCRUAL_ASSOCIATED_PLAN_FORM_URL =
  "/scheme-planning/ims/accrual/list/plan/association?accrualNumber={accrualId}&isEdited={isEdited}&pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const DELETE_ACCRUAL_URL = "/scheme-planning/ims/accrual/delete";
export const DOWNLOAD_ACCRUAL_EXPORT_FILE =
  "/scheme-planning/ims/accrual/{payload}/download/plans";
export const EDITED_LIST_IMPORT_URL =
  "/scheme-planning/ims/accrual/{accrual}/upload/plans";
export const DELETE_ACCRUAL_ASSOCIATED_PLANS_URL =
  "/scheme-planning/ims/accrual/associated/schemePlan";
export const EXECUTE_ACCRUAL_PLANS_URL = "/scheme-planning/ims/accrual/execute";
export const ACCRUAL_REPORT_EXPORT = "/Reports/ims/accrual/report/{buttonId}?accrualId={accrualId}";
export const DOWNLOAD_ADD_ACCRUAL_EXPORT_EXCEL_URL =
  "/scheme-planning/ims/accrual/{accrualId}/schemeplanlistDownload?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
